import { VideoCallEffect } from './types'
import hillLandscapeImg from '../../assets/hills_landscape.jpg'
import therapyOfficImg from '../../assets/therapy_office.jpg'

// Webpack and Vite import images as URL strings, while Metro web exports an asset descriptor.
// Return undefined for unknown shapes so a background asset cannot prevent video from starting.
export const getWebImageAssetURL = (asset: unknown): string | undefined => {
  if (typeof asset === 'string') {
    return asset || undefined
  }

  if (typeof asset !== 'object' || asset === null || !('uri' in asset)) {
    return undefined
  }

  return typeof asset.uri === 'string' && asset.uri ? asset.uri : undefined
}

export const getVideoEffectURL = (effect: VideoCallEffect): string | undefined => {
  switch (effect) {
    case VideoCallEffect.NONE:
      return undefined
    case VideoCallEffect.BLUR:
      return 'blur'
    case VideoCallEffect.OFFICE:
      return getWebImageAssetURL(therapyOfficImg)
    case VideoCallEffect.HILL_LANDSCAPE:
      return getWebImageAssetURL(hillLandscapeImg)
  }
}

export const getMobileEffectName = (effect: VideoCallEffect): string | undefined => {
  switch (effect) {
    case VideoCallEffect.NONE:
      return ''
    case VideoCallEffect.BLUR:
      return 'Blur'
    default:
      return undefined
  }
}

export const VB_BROWSERS = ['Chrome', 'Chromium', 'Firefox', 'Edge']

export const getErrorObject = (error: object) => {
  return {
    message: 'message' in error ? error.message : null,
    name: 'name' in error ? error.name : null,
    reason: 'reason' in error ? error.reason : null,
    type: 'type' in error ? error.type : null,
  }
}

// startVideo rejects with INVALID_PARAMETERS when the device fails Zoom's virtual
// background capability check, and with VIDEO_BACKGROUND_FAILED when the background
// image cannot be loaded. Zoom has not started capture in either case, so the
// camera can be started again without the background.
export const isVirtualBackgroundStartError = (error: unknown) =>
  typeof error === 'object' &&
  error !== null &&
  'type' in error &&
  (error.type === 'INVALID_PARAMETERS' || error.type === 'VIDEO_BACKGROUND_FAILED')

export const isIgnorableZoomError = (error: { type?: string; reason?: string }) =>
  error.type === 'VIDEO_USER_FORBIDDEN_CAPTURE' ||
  (error.type === 'INVALID_OPERATION' && error.reason === 'Camera is starting, please wait.')
